import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import './style.css';

export default class Introduction extends Component {
  render() {
    return (
      <section className="flex w-100 flex-row z-999">
        <Fade left cascade>
          <div className="social-media w-40 tr z-999 flex flex-column">
            <div>
              <a className="link ma0 pa0" href="https://www.instagram.com/giorgygunawan/" target="_blank" rel="noopener noreferrer">Gram</a>
            </div>
            <div className="pv2">
              <a className="link ma0 pa0" href="https://www.linkedin.com/in/giorgyg" target="_blank" rel="noopener noreferrer">Linked</a>
            </div>
            <div>
              <a className="link ma0 pa0" href="https://dribbble.com/giorgyg" target="_blank" rel="noopener noreferrer">Dribbble</a>
            </div>
          </div>
        </Fade>
        <div className="w-10"> </div>
        <Fade left cascade>
          <div className="intro-text w-50 tl z-999 ma0 pa0">
            <p>
          Giorgy gunawan — is someone who code his own design and design his own code.<br />He approaches creative works with a technical perspective.
            </p>
          </div>
        </Fade>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/Sections/Introduction/index.jsx